<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc"></h2>
<p class="center" id="cover"><img alt="Uncommon Decency: Christian Civility in an Uncivil World Cover" src="Images/9780830869060.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?dda11d24